import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
// import { DialogService } from 'app/shared/services/dialog/dialog.service';
import * as _ from 'lodash';
import { ICurrency } from '../currencies.interface';
import { CurrenciesService } from '../currencies.service';
import { CurrencyAlignment } from '../currencies.constants';
import { AuthService } from '../../../../shared/services/auth.service';

let self: any;

@Component({
  selector: 'app-currencies-modal',
  templateUrl: './currencies-modal.component.html',
  styleUrls: ['./currencies-modal.component.css']
})
export class CurrenciesModalComponent implements OnInit {
  dialog: MatDialogRef<any>;
  readOnly: boolean = false;
  loading: boolean = false;
  saving: boolean = false;
  currency!: ICurrency;
  form!: UntypedFormGroup;
  submitted = false;
  isDev!: boolean;
  CurrencyAlignment: any = CurrencyAlignment;
  CurrencyAlignmentKeys = Object.keys(CurrencyAlignment);

  constructor(
    public _CurrenciesService: CurrenciesService,
    // private _dialogService: DialogService,
    public dialogRef: MatDialogRef<any>,
    private fb: UntypedFormBuilder,
    private ref: ChangeDetectorRef,
    private _AuthService: AuthService
  ) {
    self = this;
    this.dialog = dialogRef;
  }

  ngOnInit(): void {
    this.isDev = this._AuthService.isRole('dev');
    if (this.currency._id) this.getCurrency();
    else this.buildForm();
  }

  getCurrency() {
    this.loading = true;
    this._CurrenciesService.getCurrency(this.currency._id || '').subscribe((currency) => {
      this.currency = currency;
      this.buildForm();
      this.loading = false;
    });
  }

  get f() { return this.form.controls; }
  buildForm() {
    this.form = this.fb.group({
      code: [this.currency.code, [Validators.required]],
      symbol: [this.currency.symbol, [Validators.required]],
      align: [this.currency.align, [Validators.required]],
      name: [this.currency.name, [Validators.required]],
      isDeleted: [this.currency.isDeleted]
    });
  }

  setEditable() {
    this.readOnly = false;
  }

  onSubmit() {
    this.submitted = true;
    let data: ICurrency = _.cloneDeep(this.form.value);
    if (this.form.invalid) return;
    this.saving = true;
    if (this.currency._id) {
      data._id = this.currency._id;
      this._CurrenciesService.updateCurrency(data).subscribe((currency) => {
        this.dialog.close(currency);
      });
    } else {
      this._CurrenciesService.createCurrency(data).subscribe((currency) => {
        this.dialog.close(currency);
      });
    }
  }
}